
import React, { useEffect, useState } from "react";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogDescription,
} from "@/components/ui/dialog";
import ContactForm from "./ContactForm";

const ContactModal = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [hasOpened, setHasOpened] = useState(false);

    useEffect(() => {
        // Check if we've already shown the modal in this session to avoid annoyance
        // If the user wants it EVERY time they visit the website (refresh), we can remove sessionStorage check.
        // The requirement is "after 10s when user visits the website".
        // Usually this means once per session.

        // I will use sessionStorage to ensure it doesn't pop up on every single navigation if I put it in a layout that potentially remounts or if they refresh.
        // But if "visit website" means "opens the tab", then sessionStorage is good.

        const hasShown = sessionStorage.getItem("contactModalShown");

        if (!hasShown) {
            const timer = setTimeout(() => {
                setIsOpen(true);
                setHasOpened(true);
                sessionStorage.setItem("contactModalShown", "true");
            }, 10000); // 10 seconds

            return () => clearTimeout(timer);
        }
    }, []);

    return (
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
            <DialogContent className="sm:max-w-[500px] max-h-[90vh] overflow-y-auto">
                <DialogHeader>
                    <DialogTitle className="text-xl font-bold">Get in Touch</DialogTitle>
                    <DialogDescription>
                        Interested in our properties? Leave us a message and we'll get back to you shortly.
                    </DialogDescription>
                </DialogHeader>
                <ContactForm
                    showHeading={false}
                    onSuccess={() => setIsOpen(false)}
                    className="shadow-none p-0 border-0"
                />
            </DialogContent>
        </Dialog>
    );
};

export default ContactModal;
